import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import {
  CHART_AXIS,
  CHART_COLORS,
  CHART_TOOLTIP_ITEM_STYLE,
  CHART_TOOLTIP_STYLE,
} from './chart-theme';

export interface BarItem {
  name: string;
  value: number;
}

interface HorizontalBarChartProps {
  data: BarItem[];
  height?: number;
  /** Width of the left label gutter in px. */
  yWidth?: number;
  /** Show value labels at the end of each bar. */
  showValueLabels?: boolean;
}

export function HorizontalBarChart({
  data,
  height = 240,
  yWidth = 120,
  showValueLabels = true,
}: HorizontalBarChartProps): JSX.Element {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 4, right: showValueLabels ? 48 : 12, bottom: 0, left: 0 }}
      >
        <XAxis
          type="number"
          hide
          allowDecimals={false}
          domain={[0, 'dataMax']}
        />
        <YAxis
          type="category"
          dataKey="name"
          stroke={CHART_AXIS.stroke}
          tick={CHART_AXIS.tick}
          tickLine={false}
          axisLine={false}
          width={yWidth}
          interval={0}
        />
        <Tooltip
          contentStyle={CHART_TOOLTIP_STYLE}
          itemStyle={CHART_TOOLTIP_ITEM_STYLE}
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
          formatter={(v: number) => [v.toLocaleString(), 'Users']}
        />
        <Bar
          dataKey="value"
          radius={[0, 4, 4, 0]}
          maxBarSize={20}
          isAnimationActive={false}
          label={
            showValueLabels
              ? {
                  position: 'right',
                  fill: '#CCCCCC',
                  fontSize: 12,
                  fontFamily: 'Tommy, system-ui, sans-serif',
                  formatter: (v: number | string) =>
                    typeof v === 'number' ? v.toLocaleString() : v,
                }
              : undefined
          }
        >
          {data.map((_, i) => (
            <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
